/* eslint-disable react/jsx-no-duplicate-props */
import {
  Box,
  FormControl,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import NumberFormatCustom from "../NumberFormatCustom";

const SavingGoalForm = ({
  saving,
  savingError,
  handleChangeSaving,
  handleSavingError,
  handleSetForm,
  checkSymbol,
  setOpenBottom,
  isExist,
  setIsExist,
}) => {
  return (
    <Box sx={{ marginBottom: "4px", marginLeft: "16px", marginRight: "16px" }}>
      <FormControl fullWidth sx={{ marginBottom: "16px" }}>
        <Typography
          color="textPrimary"
          sx={{
            fontFamily: "FSElliotPro",
            fontSize: "14px",
            fontWeight: "700",
            lineHeight: 1.43,
            marginBottom: "8px",
          }}
        >
          Your goal
        </Typography>
        <TextField
          variant="outlined"
          placeholder="Wedding Day"
          type="text"
          value={saving.name}
          onChange={e => {
            setIsExist(false);
            handleChangeSaving("name", e.target.value);
            checkSymbol();
          }}
          onBlur={e => {
            handleChangeSaving("name", e.target.value);
            handleSetForm();
            checkSymbol();
          }}
          error={savingError.name}
          helperText={
            savingError.name
              ? isExist
                ? "Goal name is already exists"
                : "Please enter a valid goal name"
              : null
          }
          inputProps={{
            style: {
              fontFamily: "FSElliotPro",
              fontSize: "16px",
              fontWeight: "normal",
              lineHeight: 1.5,
              padding: "12px 16px",
              borderColor: "rgba(51, 51, 51, 0.2)",
            },
            maxLength: 30,
            "data-cy": "goal-name-input",
          }}
          FormHelperTextProps={{
            style: {
              margin: "4px 0 0 0",
              color: "#be0712",
              fontFamily: "FSElliotPro",
              fontSize: "14px",
              fontWeight: "normal",
              lineHeight: 1.57,
            },
          }}
        />
      </FormControl>
      <FormControl fullWidth sx={{ marginBottom: "16px" }}>
        <Typography
          color="textPrimary"
          sx={{
            fontFamily: "FSElliotPro",
            fontSize: "14px",
            fontWeight: "700",
            lineHeight: 1.43,
            marginBottom: "8px",
          }}
        >
          Total amount you want to save
        </Typography>
        <TextField
          variant="outlined"
          placeholder="10.00"
          value={saving.target}
          onChange={e => {
            handleChangeSaving("target", e.target.value);
          }}
          onBlur={e => {
            handleChangeSaving("target", e.target.value);
            handleSavingError(
              "target",
              e.target.value < 10 || e.target.value === "" ? true : false
            );
            handleSetForm();
          }}
          error={savingError.target}
          helperText={
            (saving.target < 10 && saving.target !== "") ||
            (savingError.target && saving.target === "")
              ? "Minimum RM 10.00"
              : null
          }
          FormHelperTextProps={{
            style: {
              margin: "4px 0 0 0",
              color: "#be0712",
              fontFamily: "FSElliotPro",
              fontSize: "14px",
              fontWeight: "normal",
              lineHeight: 1.57,
            },
          }}
          inputProps={{
            style: {
              fontFamily: "FSElliotPro",
              fontSize: "16px",
              fontWeight: "normal",
              lineHeight: 1.5,
              padding: "12px 16px 12px 0",
              borderColor: "rgba(51, 51, 51, 0.2)",
            },
            inputMode: "numeric",
            maxLength: 16,
            "data-cy": "goal-amount-input",
          }}
          InputProps={{
            inputComponent: NumberFormatCustom,
            style: { paddingLeft: "16px" },
            startAdornment: (
              <InputAdornment position="start">
                <Typography
                  color="textPrimary"
                  sx={{ fontSize: "16px", fontWeight: "700", lineHeight: 1.5 }}
                >
                  RM
                </Typography>
              </InputAdornment>
            ),
          }}
        />
      </FormControl>
      <FormControl fullWidth sx={{ marginBottom: "16px" }}>
        <Typography
          color="textPrimary"
          sx={{
            fontSize: "14px",
            fontWeight: "700",
            lineHeight: 1.43,
            marginBottom: "8px",
          }}
        >
          You want to achieve your goal in
        </Typography>
        <TextField
          variant="outlined"
          placeholder="12 Months"
          value={
            saving.period
              ? `${saving.period} ${saving.period > 1 ? "Months" : "Month"}`
              : ""
          }
          onClick={() => setOpenBottom(true)}
          error={savingError.period}
          helperText={savingError.period && "Please select period"}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <ExpandMoreOutlinedIcon color="primary" sx={{ fontSize: 24 }} />
            ),
          }}
          inputProps={{
            style: {
              fontFamily: "FSElliotPro",
              fontSize: "16px",
              fontWeight: "normal",
              lineHeight: 1.5,
              padding: "12px 16px",
              borderColor: "rgba(51, 51, 51, 0.2)",
            },
            "data-cy": "goal-period-input",
          }}
          FormHelperTextProps={{
            style: {
              margin: "4px 0 0 0",
              color: "#be0712",
              fontFamily: "FSElliotPro",
              fontSize: "14px",
              fontWeight: "normal",
              lineHeight: 1.57,
            },
          }}
        />
      </FormControl>
    </Box>
  );
};

export default SavingGoalForm;
